<template>
    <div class="music-list">
        <div class="header">
            <a-button type="primary" @click="showAdd=true,name=''">添加音樂</a-button>
        </div>
        <a-table
                :dataSource="list"
                :loading="loading"
                rowKey="id"
                :pagination="false">
            <a-table-column
                    title="音樂名稱"
                    dataIndex="title">

            </a-table-column>
            <a-table-column
                    title="播放">
                <template slot-scope="row,item,index">
                    <audio style="display: block;" controls :src="item.voicePath"></audio>
                </template>
            </a-table-column>
            <a-table-column
                    title="上傳時間">
                <template slot-scope="item,row,index">
                    {{row.addTime | trans-date}}
                </template>
            </a-table-column>
            <a-table-column
                    title="操作">
                    <template slot-scope="row,item,index">
                        <a-button size="small" @click="del(item)">刪除</a-button>
                    </template>
            </a-table-column>
        </a-table>
        <a-modal
                title="添加音樂"
                :visible="showAdd"
                @ok="action"
                :confirmLoading="loading"
                @cancel="hideAdd"
        >
            <a-form>
                <a-form-item
                        label="音樂名稱"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                >
                    <a-input placeholder="請輸入音樂名稱" v-model="name"></a-input>
                </a-form-item>
                <a-form-item
                        label="音乐类型"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                >
                    <a-radio-group v-model="musicType">
                        <a-radio :value="1">本地音乐上传</a-radio>
                        <a-radio :value="2">网络音乐</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item
                        label="試聽"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                >
                    <audio v-if="url!==''" style="display: block;width:240px;" controls  :src="url"></audio>
                    <span v-else>暫未上傳</span>
                </a-form-item>
                <a-form-item
                        v-if="musicType === 2"
                        label="音樂地址"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                ><a-input placeholder="请输入mp3格式音乐地址" v-model="url"></a-input></a-form-item>
                <a-form-item
                        v-if="musicType === 1"
                        label="上傳音樂"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                >
                    <a-upload-dragger
                            name="file"
                            :withCredentials="true"
                            :customRequest="upMusic"
                            :showUploadList="false"
                            :disabled="updisabled"
                            accept="audio/*" >
                        <p class="ant-upload-drag-icon">
                            <a-icon :type="updisabled?'loading':'inbox'" />
                        </p>
                        <p class="ant-upload-text">點擊上傳文件</p>
                        <p class="ant-upload-hint">可以直接拖拽文件到此上傳</p>
                    </a-upload-dragger>
                </a-form-item>
            </a-form>
        </a-modal>
        <a-pagination v-model="currentPage" :defaultPageSize="para.pageSize" :total="total" @change="currentChange" />
    </div>
</template>
<script>
    export default {
        data() {
            return {
                list:[],
                currentPage:1,
                total:0,
                updisabled:false,
                loading:false,
                showAdd:false,
                name:'',
                musicId:'',
                para:{
                    pageSize:6,
                    pageIndex:1
                },
                url:'',
                musicType:1
            }
        },
        methods: {
            del(item){
                let self=this;
                this.$Confirm({
                    title:'確定刪除嗎？',
                    onOk(){
                        self.$http({
                            method: 'post',
                            url: '/manager/voice/delete',
                            data:{
                                id:item.id
                            }
                        }).then(function(res){
                            self.$Message.success('操作成功')
                            self.getList()
                        }).catch(err=>{
                        })
                    },
                    onCancel(){
                    }
                })
            },
            currentChange(val){
                this.para.pageIndex=val;
                this.getList()
            },
            action(){
                let self=this;
                if(this.name===''){
                    this.$Message.warning('請輸入音樂名稱')
                    return false;
                }
                if(this.musicType === 1){
                    if(this.musicId===''){
                        this.$Message.warning('請先上傳音樂')
                        return false;
                    }
                }else{
                    if(!this.url || this.url === ''){
                        this.$Message.warning('请输入音乐地址')
                        return false;
                    }
                    if(!/https:\/\/[A-z./\d]*?mp3/.test(this.url)){
                        this.$Message.warning('音乐地址格式有误，只支持mp3格式且必须是https协议')
                        return false;
                    }
                }
                let data={
                    title:self.name,
                }
                if(this.musicType === 1){
                    data.voiceId=self.musicId;
                }else{
                    delete data.voiceId;
                    data.voiceNetPath=this.url
                }
                this.$http({
                    method: 'post',
                    url: '/manager/voice/add',
                    data:data
                }).then(function(res){
                    self.$Message.success('操作成功')
                    self.hideAdd();
                    self.getList();
                }).catch(err=>{
                    self.loading=false;
                })
            },
            upMusic(file){
                let self=this;
                this.updisabled=true;
                let param = new FormData()
                param.append('files', file.file)
                let config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };
                this.$http.post('/manager/media/upload/voice',param,config)
                    .then(res => {
                        self.updisabled=false;
                        self.musicId=res.data.mediaInfo[0].id;
                        self.url=res.data.mediaInfo[0].path;
                        self.$Message.success('上传成功')
                    }).catch(err=>{
                        self.$Message.warning('音樂上傳失敗');
                        self.updisabled=false;
                })
            },
            getList(){
                let self=this;
                this.loading=true;
                this.$http({
                    method: 'post',
                    url: '/manager/voice/list',
                    data:self.para
                }).then(function(res){
                    self.loading=false;
                    self.list=res.data.list;
                    self.total=res.data.totalRows;
                    self.currentPage=res.data.pageIndex;
                }).catch(err=>{
                    self.loading=false;
                })
            },
            hideAdd(){
                this.showAdd=false;
                this.name='';
                this.musicId=''
                this.url=''
            }
        },
        created() {
            this.getList();
            this.$emit('breadcrumbChange',['音樂管理','音樂列表'])
        },
    }
</script>
<style lang="less">
    div.music-list{
        .header{
            margin-bottom:20px;
            text-align: left;
        }
    }
</style>